import { defineEntity, custom, lifecycle } from './_helpers.js';

export default defineEntity('bcp', {
    submitted: lifecycle(),
    activated: custom({ scope: 'state' }),
    reviewDue: lifecycle(),
    'initialResponse.linked':        custom({ scope: 'state' }),
    'initialResponse.unlinked':      custom({ scope: 'state' }),
    'document.linked':               custom({ scope: 'state' }),
    'document.unlinked':             custom({ scope: 'state' }),
    'exercise.linked':               custom({ scope: 'state' }),
    'exercise.unlinked':             custom({ scope: 'state' }),
    'process.linked':                custom({ scope: 'state' }),
    'process.unlinked':              custom({ scope: 'state' }),
    'asset.linked':                  custom({ scope: 'state' }),
    'asset.unlinked':                custom({ scope: 'state' }),
    'vendor.linked':                 custom({ scope: 'state' }),
    'vendor.unlinked':               custom({ scope: 'state' }),
    'team.linked':                   custom({ scope: 'state' }),
    'team.unlinked':                 custom({ scope: 'state' }),
    'bia.linked':                    custom({ scope: 'state' }),
    'bia.unlinked':                  custom({ scope: 'state' }),
    'communication.linked':          custom({ scope: 'state' }),
    'communication.unlinked':        custom({ scope: 'state' }),
    'location.linked':               custom({ scope: 'state' }),
    'location.unlinked':             custom({ scope: 'state' }),
});
